/* eslint-disable import/prefer-default-export */
type costItem = {
  amount_origin: number;
  amount_target: number;
  approved_by_shipper: boolean;
  cost_type: number;
  created: string;
  created_by: string;
  currency_origin: string;
  custom_charge_code: string;
  description: string;
  id: number;
  measurement_unit: number;
  measurement_unit_display: string;
  original_cost: number;
  quantity: string;
  target_currency_code: string;
};
export const flattenCostItems = (costItems: Record<string, costItem[]>) =>
  Object.keys(costItems ?? []).reduce(
    (acc: costItem[], key) => [...acc, ...costItems[key].map((costItem) => ({ ...costItem, costType: key }))],
    [],
  );
